import { Alert } from 'antd';

/**
 * Alert di configurazione condiviso dai widget grafici renderizzati solo lato
 * PDF (es. interruzione di pagina, riepilogo secondario), che non sono visibili
 * in fase di compilazione.
 */
export function PdfElementConfigAlert() {
  return (
    <Alert
      style={{ marginBottom: 16 }}
      message="Elemento Documento PDF"
      description="Questo elemento non è visibile in fase di compilazione, ma sarà applicato
  nel pdf generato."
    />
  );
}
